var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kakao",
    transform: "translate(-237.57 -477.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3",
    "data-name": "\\uADF8\\uB8F9 3",
    transform: "translate(237.57 477.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2",
    "data-name": "\\uADF8\\uB8F9 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M250.568,477.9c-7.178,0-13,4.594-13,10.264,0,3.646,2.411,6.839,6.032,8.666l-1.226,4.571a.382.382,0,0,0,.093.392.362.362,0,0,0,.492.021l5.267-3.556a16.308,16.308,0,0,0,2.34.171c7.18,0,13-4.594,13-10.264S257.748,477.9,250.568,477.9Z",
    transform: "translate(-237.57 -477.902)",
    fill: "#12233a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4",
    "data-name": "\\uADF8\\uB8F9 4",
    transform: "translate(239.942 485.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M254.637,525.268h-1.419a.934.934,0,0,1-.5-.134.558.558,0,0,1-.26-.381,1.3,1.3,0,0,1-.02-.146.575.575,0,0,1,.222-.483.886.886,0,0,1,.559-.175h4.337a.927.927,0,0,1,.5.134.565.565,0,0,1,.262.381.644.644,0,0,1,.01.142.59.59,0,0,1-.217.489.871.871,0,0,1-.554.171h-1.419l0,4.889a.791.791,0,0,1-.205.567.721.721,0,0,1-.55.212.759.759,0,0,1-.48-.154.708.708,0,0,1-.253-.425.816.816,0,0,1-.013-.2Z",
    transform: "translate(-252.434 -523.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M280.677,523.662a.679.679,0,0,1,.274-.367.876.876,0,0,1,.461-.11h.36a.946.946,0,0,1,.49.119.789.789,0,0,1,.311.454l1.812,5.253a3.077,3.077,0,0,1,.122.419,1.664,1.664,0,0,1,.027.18.663.663,0,0,1-.212.486.686.686,0,0,1-.5.2.639.639,0,0,1-.674-.428l-.389-1.144h-2.416l-.39,1.144a.627.627,0,0,1-.672.428.7.7,0,0,1-.444-.137.622.622,0,0,1-.23-.387.8.8,0,0,1-.014-.16.9.9,0,0,1,.041-.276c.029-.108.064-.218.1-.323Zm.908,1.219h-.019l-.885,2.756h1.757Z",
    transform: "translate(-274.441 -523.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M317.27,523.964a.782.782,0,0,1,.205-.564.721.721,0,0,1,.55-.215.747.747,0,0,1,.482.157.712.712,0,0,1,.25.425.74.74,0,0,1,.013.2v4.892h2.508a.9.9,0,0,1,.508.134.573.573,0,0,1,.255.381,1.028,1.028,0,0,1,.022.143.579.579,0,0,1-.222.486.888.888,0,0,1-.559.172h-3.131a1,1,0,0,1-.564-.143.687.687,0,0,1-.284-.465,2.023,2.023,0,0,1-.033-.306Z",
    transform: "translate(-306.971 -523.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M348.252,523.964a.79.79,0,0,1,.205-.564.724.724,0,0,1,.55-.215.743.743,0,0,1,.48.157.7.7,0,0,1,.252.425.747.747,0,0,1,.015.2l0,2.273,2.359-2.709a1.611,1.611,0,0,1,.285-.259.569.569,0,0,1,.313-.084.769.769,0,0,1,.449.14.56.56,0,0,1,.249.367c0,.006.006.026.012.058a.217.217,0,0,0,0,.064.6.6,0,0,1-.07.285,1.326,1.326,0,0,1-.179.25l-1.542,1.685,1.824,2.89.055.087a1.559,1.559,0,0,1,.216.437c0,.005.005.023.011.046a.232.232,0,0,0,0,.049.686.686,0,0,1-.225.576.867.867,0,0,1-.546.174.747.747,0,0,1-.374-.081.978.978,0,0,1-.3-.326l-1.73-2.785-.824.858.007,1.554a.8.8,0,0,1-.207.567.722.722,0,0,1-.55.212.765.765,0,0,1-.481-.154.708.708,0,0,1-.252-.425.932.932,0,0,1-.013-.2Z",
    transform: "translate(-333.039 -523.185)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.7374d6d840ceb1c02484963df9d2cdc2.svg";
export { ForwardRef as ReactComponent };